import revive_payload_client_4sVQNw7RlN from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import slideovers_X7whXyrIWR from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import plugin_client_W86eSGFqyZ from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/node_modules/nuxt-viewport/dist/runtime/plugin.client.mjs";
import axios_sVCuMR6hEC from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/plugins/axios.js";
import emailClient_f56zRh6WmM from "C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/plugins/emailClient.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  plugin_client_W86eSGFqyZ,
  axios_sVCuMR6hEC,
  emailClient_f56zRh6WmM
]